import { render, staticRenderFns } from "./TestItems.vue?vue&type=template&id=2977b686&scoped=true&"
import script from "./TestItems.vue?vue&type=script&lang=js&"
export * from "./TestItems.vue?vue&type=script&lang=js&"
import style0 from "./TestItems.vue?vue&type=style&index=0&id=2977b686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977b686",
  null
  
)

export default component.exports